<template>
    <div class="deposit-offexchange">
        <div class="wrap-content">
            <div class="title-page">Deposit</div>
            <!-- <div class="nav-tab">
                <span class="tab" :class="{ activeTab: typePage == 'deposit' }" @click="filterTypeDeposit('deposit')">List Deposit</span>
                <span class="tab" :class="{ activeTab: typePage == 'metal' }" @click="filterTypeDeposit('metal')">List Metal</span>
            </div> -->
            <list-deposit-off
                v-if="typePage == 'deposit'"
                :depositDatas="getDataDeposit"
                :totalDeposit="getTotalData"
                :pageNumber="currentPage"
                :totalPerPage="perPage"
                :isLoadingData="isLoading"
                @setFilterTable="filterTable"
            ></list-deposit-off>
            <list-metal-off
                v-else
                :depositDatas="getDataDeposit"
                :totalDeposit="getTotalData"
                :pageNumber="currentPage"
                :totalPerPage="perPage"
                :isLoadingData="isLoading"
            ></list-metal-off>

            <div class="d-flex justify-content-end mt-3">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="getTotalData"
                    :per-page="perPage"
                    @change="handlePageChange"
                    aria-controls="new-table"
                    first-number
                    last-number
                    v-show="getTotalData > 10"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import ListDepositOff from "./ListDepositOff.vue";
import ListMetalOff from "./ListMetalOff.vue";
export default {
    components: { ListDepositOff, ListMetalOff },
    data() {
        return {
            role: sessionStorage.getItem("role"),
            typePage: "deposit",
            isShowFilter: false,
            dataClient: [],
            today: "",
            currentPage: 1,
            perPage: 10,
            lengthData: 1,
            typeDeposit: "offexchange",
            contract_id: "",
            owner: "",
            hallmark: "",
            activity: "deposit",
            startDate: "",
            endDate: "",
            serialNumber: "",
            status: [],
            dateType: "",
        };
    },
    mounted() {
        this.today = new Date().toISOString().split("T")[0];
        axios.get("/v2/clearing/admin/abx/get/list_depositor?type=offexchange").then((res) => {
            this.dataClient = res.data.data.body;
        });
        this.getData(
            this.activity,
            this.owner,
            this.startDate,
            this.endDate,
            this.serialNumber,
            this.hallmark,
            this.status,
            this.dateType,
            this.perPage,
            this.currentPage,
            this.contract_id,
            this.typeDeposit
        );
    },
    computed: {
        getDataDeposit() {
            return this.$store.state.vaultModul.depositData;
        },
        getTotalData() {
            return this.$store.state.vaultModul.totalData;
        },
        isLoading() {
            return this.$store.state.vaultModul.isLoading;
        },
        getDataContract() {
            return this.$store.state.vaultModul.dataContract;
        },
        getDataClient() {
            return this.$store.state.vaultModul.dataClient;
        },
    },
    methods: {
        handlePageChange(event) {
            this.currentPage = event;
            this.getData(
                this.activity,
                this.owner,
                this.startDate,
                this.endDate,
                this.serialNumber,
                this.hallmark,
                this.status,
                this.dateType,
                this.perPage,
                this.currentPage,
                this.contract_id,
                this.typeDeposit
            );
        },
        filterTypeDeposit(event) {
            this.typePage = event;
            this.getData(
                this.activity,
                this.owner,
                this.startDate,
                this.endDate,
                this.serialNumber,
                this.hallmark,
                this.status,
                this.dateType,
                this.perPage,
                this.currentPage,
                this.contract_id,
                this.typeDeposit
            );
        },
        filterTable(event) {
            this.status = event.statusMetal;
            this.startDate = event.startDate;
            this.endDate = event.endDate;
            this.getData(
                this.activity,
                this.owner,
                this.startDate,
                this.endDate,
                this.serialNumber,
                this.hallmark,
                this.status,
                this.dateType,
                this.perPage,
                this.currentPage,
                this.contract_id,
                this.typeDeposit
            );
        },
        getData(activity, owner, startDate, endDate, serialNumber, hallmark, status, dateType, perPage, currentPage, contract_id, type) {
            if (this.typePage == "deposit") {
                this.$store.dispatch("getListDeposit", {
                    serialNumber: serialNumber,
                    perPage: perPage,
                    currentPage: currentPage,
                    owner: owner,
                    startDate: startDate,
                    endDate: endDate,
                    status: status,
                    type: type,
                });
            } else {
                this.$store.dispatch("getListMetal", {
                    activity: activity,
                    perPage: perPage,
                    currentPage: currentPage,
                    startDate: startDate,
                    endDate: endDate,
                    type: type,
                    owner: owner,
                    serialNumber: serialNumber,
                    hallmark: hallmark,
                    dateType: dateType,
                    status: status,
                    contract_id: contract_id,
                });
            }
        },
    },
};
</script>

<style scoped>
.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.nav-tab {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 2rem;
    color: #636366;
    padding: 0.8rem 0;
    justify-self: flex-start;
}

.tab {
    padding: 0.8rem 1rem;
    cursor: pointer;
}

.tab:hover,
.activeTab {
    color: var(--clr-scondary);
    border-bottom: 2px solid var(--clr-scondary);
}

/* .clearing {
    font-weight: 600;
    color: rgb(50, 90, 115);
    border-radius: 5px;
}
.operator {
    font-weight: 600;
    color: rgb(252, 108, 4);
    border-radius: 5px;
}
.abx {
    font-weight: 600;
    color: rgb(172, 143, 26);
    border-radius: 5px;
}
.stored {
    font-weight: 600;
    color: rgb(40, 167, 69);
    border-radius: 5px;
}

.vendor {
    font-weight: 600;
    color: rgb(250, 194, 75);
    border-radius: 5px;
}

.reject {
    font-weight: 600;
    color: rgb(250, 119, 75);
    border-radius: 5px;
} */
</style>
